import { useTranslation } from 'react-i18next';
import { Progress, theme } from 'antd';

import MapLoadingIcon from '@/comp/common/icons/MapLoadingIcon';

import GridBackground from '../../GridBackground';
import { LoadingScreenContainer } from './LoadingScreen.styles';

const LoadingScreen = ({ progressPercent }: { progressPercent?: number }) => {
  const { t } = useTranslation();
  const { token } = theme.useToken();

  return (
    <LoadingScreenContainer>
      <GridBackground isVisible width="500px" height="400px" />
      <div className="loading-content-container">
        <MapLoadingIcon />
        <span className="loading-title">{t('loadingPIDEditor')}</span>
        <span className="loading-description">{t('loadingPIDEditorDescription')}</span>
        <Progress showInfo={false} percent={progressPercent} strokeColor={token.colorPrimary} />
      </div>
    </LoadingScreenContainer>
  );
};

export default LoadingScreen;
